export const apiBaseUrl = 'https://api.ken42.com/school/stage/pfsportal';
export const tokenUrl = 'https://dev-portal.ken42.com/api/app/azureToken';
export const clientUid = 'vkgi';
export const KEY_ACCESS_TOKEN = 'KEY_ACCESS_TOKEN';
export const KEY_ACCESS_TOKENS = 'KEY_ACCESS_TOKENS';

export const instituteUrl = 'https://api.ken42.com/schoolstageapp';
export const mailUrl = 'https://api.ken42.com/dev/pfs';
export const configUrl = 'https://config-api.ken42.com/v1/configs/url';
export const adminURL = 'https://api-v2.ken42.com/dev-admin';
export const eventDateFormate = 'MMMM Do YYYY hh:mm a';
export const dateFormate = 'YYYY-MM-DD';
export const dateTimeFormate = 'hh:mm:ss a';
export const examModuleURL = `https://ken426--playground.my.salesforce.com`;
export const ACCESS_TOKEN = 'access_token';
